<div class="lp-statistics-table">
  <div class="lp-statistics-table__header">
    <lp-statistics-widget-header [title]="title"></lp-statistics-widget-header>
  </div>

  <div
    *ngIf="items.length; else noDataTmp"
    class="lp-statistics-table__content"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
  >
    <tui-scrollbar>
      <ng-container *tuiLet="currentPage$ | async as currentPage">
        <ng-container *tuiLet="pageSize$ | async as pageSize">
          <table tuiTable [columns]="columns">
            <thead>
              <tr tuiThGroup>
                <ng-container *ngFor="let column of columns; let indexF = index">
                  <th *tuiHead="column" tuiTh>{{ getCaption(column) | translate }}</th>
                </ng-container>
              </tr>
            </thead>
            <tbody *tuiLet="items | tuiTableSort as sortedItems" tuiTbody [data]="sortedItems">
              <ng-container *ngFor="let item of sortedItems; let index = index">
                <ng-container *ngIf="currentPage !== null && pageSize !== null">
                  <ng-container *ngIf="currentPage * pageSize <= index && index < (currentPage + 1) * pageSize">
                    <tr *ngIf="showAll ? index < previewCount : true" tuiTr>
                      <ng-container *ngFor="let column of columns; let indexF = index">
                        <td *tuiCell="column" tuiTd>
                          <ng-container *ngIf="!['datePublished', 'discountDate'].includes(column); else dateTmp">
                            <ng-container *ngIf="!['name'].includes(column); else productLinkTmp">
                              <ng-container *ngIf="!['userName'].includes(column); else userLinkTmp">
                                {{ getItemValue(item, column) }}
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </td>

                        <ng-template #productLinkTmp>
                          <app-link
                            [routerLink]="'/loyalty/product/' + getItemValue(item, 'id')"
                            [queryParams]="{ unionId }"
                            [displayText]="getItemValue(item, column)"
                          ></app-link>
                        </ng-template>

                        <ng-template #userLinkTmp>
                          <ng-container *ngIf="!!getItemValue(item, 'userName'); else hiddenTmp">
                            <ng-container *ngIf="!!getItemValue(item, 'userId'); else userTmp">
                              <app-link
                                [routerLink]="'/association-users/' + getItemValue(item, 'userId')"
                                [displayText]="getItemValue(item, column)"
                              ></app-link>
                            </ng-container>
                          </ng-container>
                        </ng-template>

                        <ng-template #userTmp>
                          {{ getItemValue(item, column) }}
                        </ng-template>

                        <ng-template #hiddenTmp>
                          {{ 'components.lpStatisticsTable.label.hidden' | translate }}
                        </ng-template>

                        <ng-template #dateTmp>
                          {{ getItemValue(item, column) | date: 'dd.MM.yyyy' }}
                        </ng-template>
                      </ng-container>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>

            <tfoot *ngIf="pageSize && showPagination && !showAll">
              <tr>
                <td [colSpan]="columns.length">
                  <tui-table-pagination
                    [total]="items.length"
                    [page]="currentPage || 0"
                    [size]="pageSize"
                    (paginationChange)="onChangePagination($event)"
                  ></tui-table-pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </ng-container>
      </ng-container>
    </tui-scrollbar>
  </div>

  <ng-template #noDataTmp>
    <div class="no-data" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
      {{ 'common.labels.noData' | translate }}
    </div>
  </ng-template>
</div>

<div *ngIf="showAll" class="footer">
  <button tuiButton class="footer__button" type="button" [size]="'m'" (click)="onShowAll()">
    {{ 'components.lpStatisticsTable.buttons.footerButton' | translate }}
  </button>
</div>
